import { render, staticRenderFns } from "./techniqueList.vue?vue&type=template&id=37c7d794&scoped=true&"
import script from "./techniqueList.vue?vue&type=script&lang=js&"
export * from "./techniqueList.vue?vue&type=script&lang=js&"
import style0 from "./techniqueList.vue?vue&type=style&index=0&id=37c7d794&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c7d794",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VCol,VIcon,VRow,VTextField})
